import React, {useState, useEffect} from 'react'
import {FaLinkedinIn, FaGithub, FaInstagram, FaYoutube} from 'react-icons/fa'
import Logo from '../assets/logo.png'
import {AiOutlineClose, AiOutlineMenu} from 'react-icons/ai'
const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
}
const Navbar = () => {
    const [nav, setNav] = useState(false);
    const [shadow, setshadow] = useState(false);
    const handleNav = ()=> setNav(!nav);

    useEffect(()=>{
        const handleShadow = () =>{
            if(window.scrollY >= 90){
                setshadow(true);
            }
            else{
                setshadow(false);
            }
        }
        window.addEventListener('scroll', handleShadow);
    }, [])


  return (
      <div style = {{backgroundColor : "#ecf0f3" }} className = {shadow ? 'fixed w-full h-20 shadow-xl z-[100]' : 'fixed w-full h-20 z-[100]'}>
          <div className = "flex justify-between items-center w-full h-full px-2 2xl:px-16">
                <img src={Logo} alt="" style = {{width:'75px'}} />
            <div>
                <ul className = "hidden md:flex mr-12 ">
                    <a href = "#home">
                    <li className = "ml-10 text-sm uppercase hover:border-b">HOME</li>
                    </a>
                    <a href = "#about">
                    <li className = "ml-10 text-sm uppercase hover:border-b">ABOUT</li>
                    </a>
                    <a href = "#skills">
                    <li className = "ml-10 text-sm uppercase hover:border-b">Skills</li>
                    </a>
                    <a href = "#projects">
                    <li className = "ml-10 text-sm uppercase hover:border-b">Projects</li>
                    </a>
                    <a href = "#contact">
                    <li className = "ml-10 text-sm uppercase hover:border-b">Contact</li>
                    </a>
                </ul>
                <div onClick = {handleNav} className = "md:hidden">
                    <AiOutlineMenu size = {25} />
                </div>
            </div>
          </div>
          <div className ={nav ? "md:hidden fixed left-0 top-0 w-full h-screen bg-black/70" : ""} >
              <div className ={nav ? "fixed left-0 top-0 w-[75%] sm:w-[60%] md:w-[45%] h-screen bg-[#ecf0f3] p-10 ease-in duration-500" : "fixed left-[-100%] top-0 p-10 ease-in duration-500"} >
                <div>
                    <div className = "flex w-full items-center justify-between">
                        <img src={Logo} alt="" style = {{width:'100'}, {height:'50px'}}/>
                        <div onClick = {handleNav} className = "rounded-full shadow-lg shadow-gray-400 p-3 cursor-pointer">
                            <AiOutlineClose />
                        </div>
                    </div>
                    <div className = "border-b border-gray-300 my-4">
                        <p className = "w-[85%] md:w-[90%] py-4 ">Let's Start Coding</p>
                    </div>
                </div>
                <div className = 'py-4 flex flex-col'>
                    <ul className = 'uppercase'>
                        <a href = "#home">
                    <li onClick = {() => setNav(false)} className = "py-4 text-sm">HOME</li>
                    </a>
                    <a href = "#about">
                    <li onClick = {() => setNav(false)} className = "py-4 text-sm">ABOUT</li>
                    </a>
                    <a href = "#skills">
                    <li onClick = {() => setNav(false)} className = "py-4 text-sm">Skills</li>
                    </a>
                    <a href = "#projects">
                    <li onClick = {() => setNav(false)} className = "py-4 text-sm">Projects</li>
                    </a>
                    <a href = "#contact">
                    <li onClick = {() => setNav(false)} className = "py-4 text-sm">Contact</li>
                    </a>
                    </ul>
                    <div className = 'pt-40'>
                        <p className = "uppercase tracking-widest text-[#5651e5]">Let's Connect</p>
                        <div className = "flex items-center justify-between my-4 w-full sm:w-[80%]">
                            <div className = "rounded-full shadow-lg shadow-gray-400 p-3 cursor-pointer hover:scale-105 ease-in duration-300" onClick={() => openInNewTab('https://www.linkedin.com/in/ankur-gupta-a93832201/')}>
                                <FaLinkedinIn />
                            </div>
                            <div className = "rounded-full shadow-lg shadow-gray-400 p-3 cursor-pointer hover:scale-105 ease-in duration-300" onClick={() => openInNewTab('https://github.com/Modernbeast02')}>
                                <FaGithub />
                            </div>
                            <div className = "rounded-full shadow-lg shadow-gray-400 p-3 cursor-pointer hover:scale-105 ease-in duration-300" onClick={() => openInNewTab('https://www.instagram.com/ankurgupta_0205/')}>
                                <FaInstagram />
                            </div>
                            <div className = "rounded-full shadow-lg shadow-gray-400 p-3 cursor-pointer hover:scale-105 ease-in duration-300" onClick={() => openInNewTab('https://www.youtube.com/channel/UCHDKLvHgL-Anxe1LNekleVw')}>
                                <FaYoutube />
                            </div>
                        </div>
                    </div>
                </div>
              </div>
          </div>
      </div>
  )
}

export default Navbar
